import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface VirtualTourInputProps {
  value: string;
  onChange: (value: string) => void;
}

export const VirtualTourInput = ({ value, onChange }: VirtualTourInputProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="virtual_tour">Virtual Tour URL</Label>
      <Input
        id="virtual_tour"
        type="url"
        placeholder="Enter virtual tour URL (e.g., Matterport, YouTube)"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <p className="text-sm text-muted-foreground">
        Add a link to your virtual tour from services like Matterport, YouTube, or other 360° tour providers
      </p>
    </div>
  );
};